import { CoralHandler, CoralInterceptor, CoralRequest, CoralResponse } from '@amzn/ihm-js-coral-client';

import { Observable } from 'rxjs';

export default class AuxiliaryRequestInterceptor extends CoralInterceptor {
    intercept(request: CoralRequest, next: CoralHandler): Observable<CoralResponse<unknown>> {
        return next.handle(AuxiliaryRequestInterceptor.addOmitCredentials(request));
    }

    /**
     * FIX: To avoid CORS access control errors when credential mode is `include`
     * In CoralRequest class, `credentials` are by default set to `included` if it is either undefined | null | empty string
     * https://code.amazon.com/packages/IhmJSCoralClient/blobs/2166c3ea992ea581bea925c309907f20b2cb7863/--/src/client/coral-request.ts#L59
     * Hence to avoid switching to `include` automatically, setting it to `omit`
     */
    private static addOmitCredentials(request: CoralRequest): CoralRequest {
        const cloneOptions: any = {
            credentials: 'omit'
        };

        return request.clone(cloneOptions);
    }
}
